<template>
  <div>
    <ul class="rightMenu">
      <li>
        <v-btn text plain depressed link
               class="link-btn"
               :href="getURLLocalGlobal('/resources/herbalgram/current-issue/')"
               @click="goToPage('/resources/herbalgram/current-issue/', $event)">
          Current Issue
        </v-btn>

      </li>
      <li>
        <v-btn text plain depressed link
               class="link-btn"
               :href="getURLLocalGlobal('/resources/herbalgram/issues/')"
               @click="goToPage('/resources/herbalgram/issues/', $event)">
          Issues
        </v-btn>
      </li>
      <li>
        <v-btn text plain depressed link class="link-btn"
               :href="getURLLocalGlobal('/resources/herbalgram/departments/')"
               @click="goToPage('/resources/herbalgram/departments/', $event)">
          Departments
        </v-btn>
      </li>
      <li>
        <v-btn text plain depressed link class="link-btn"
               :href="getURLLocalGlobal('/resources/herbalgram/authors/')"
               @click="goToPage('/resources/herbalgram/authors/', $event)">
          Authors
        </v-btn>
      </li>
      <li>
        <v-btn text plain depressed link class="link-btn" :href="getURLLocalGlobal('/get-involved/advertising-page/')"
               @click="goToPage('/get-involved/advertising-page/', $event)">
          Advertise
        </v-btn>
      </li>
      <li>
        <v-btn target="_blank" text plain depressed link class="link-btn"
               :href="getURLLocalGlobal('https://umb.herbalgram.org/media/x4pbfxbo/hg_article_guidelines.pdf')">
          Submit Articles
        </v-btn>
      </li>
      <li>
        <v-btn text plain depressed link class="link-btn"
               :href="getURLLocalGlobal('/get-involved/estore-information-page/')"
               @click="goToPage('/get-involved/estore-information-page/', $event)">
          Order Issues
        </v-btn>
      </li>
      <li>
        <v-btn text plain depressed link class="link-btn"
               :href="getURLLocalGlobal('/about-us/programs-services/#Reprint_Requests')"
               @click="goToPage('/about-us/programs-services/#Reprint_Requests', $event)"
        >
          Reprint Articles
        </v-btn>
      </li>
    </ul>
  </div>
</template>

<script>
import globalMixins from "@/mixins/globalMixins";

export default {
  name: 'HgRightMenu',

  mixins: [globalMixins],

  data: () => ({}),

  created() {

  }
}
</script>

<style>

</style>
